import React, { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import SideNav from "../components/navigation/SideNav";
import TopBar from "../components/navigation/TopBar";

const ContentLayout: React.FC = () => {
  const [selectedNavItemLabel, setSelectedNavItemLabel] = useState("");
  const [isMobileDrawerOpen, setMobileDrawerOpen] = useState(false);

  // State for user data
  const [user, setUser] = useState<{ firstName?: string; lastName?: string; profilePicture?: string }>({});

  // Load user data from localStorage when component mounts
  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
  }, []);

  const handleNavItemClick = (item: string) => {
    setSelectedNavItemLabel(item);
    setMobileDrawerOpen(false); // Close the drawer after selecting an item on mobile
  };

  const toggleMobileDrawer = () => {
    setMobileDrawerOpen(!isMobileDrawerOpen);
  };

  return (
    <div className="flex h-screen">
      {/* Fixed Sidebar for larger screens */}
      <div className="hidden md:block w-[20%] h-full fixed top-0 left-0 bg-gray-100">
        <SideNav onNavItemClicked={handleNavItemClick} />
      </div>

      {/* Mobile Drawer */}
      {isMobileDrawerOpen && (
        <div className="fixed inset-0 z-50 bg-black bg-opacity-50 md:hidden" onClick={toggleMobileDrawer}>
          <div
            className="w-[75%] h-full bg-white p-4"
            onClick={(e) => e.stopPropagation()} // Prevent closing drawer when clicking inside it
          >
            <SideNav onNavItemClicked={handleNavItemClick} />
          </div>
        </div>
      )}

      {/* Main Content Area */}
      <div className="flex-1 md:ml-[20%]">
        {/* Fixed Top Bar */}
        <div className="fixed top-0 left-0 w-full z-59 md:z-50 md:w-[80%] md:left-[20%] ">
          <TopBar
            selectedNavItemLabel={selectedNavItemLabel}
            userProfile={{
              firstName: user.firstName,
              lastName: user.lastName,
              profilePicture: user.profilePicture,
            }}
            onHamburgerClick={toggleMobileDrawer} // Pass hamburger click handler
          />
        </div>

        {/* Scrollable content area */}
        <div className="bg-[#F3F6FF] pt-[70px] px-8 pb-5 h-full overflow-y-auto">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default ContentLayout;
